import React, { useState } from 'react'
import { Col, Container, Row, Form, Button, Modal } from 'react-bootstrap';
import styles from './createQuestions.module.scss';
import ReactTooltip from 'react-tooltip';
import { Formik, FieldArray } from 'formik';
import { CustomTextField } from '../../../../../shared/customTextField';
import { CustomSwitch } from '../../../../../shared/customSwitch';
import { CustomAlertBox } from '../../../../../shared/customAlertBox';
import { CustomButton } from '../../../../../shared/customButton';
import { CustomCheckBox } from '../../../../../shared/customCheckBox';
import { addQuestionToQuizTemplate } from '../../../../../../services/util/quizTemplates';
import * as yup from 'yup';

const CreateQuestionModal = (props) => {

    let [isMultipleAnswers, setMultipleAnswers] = useState(false);
    let [emptyQuestionError, setEmptyQuestionError] = useState(false);
    let [noEnoughSelectedAnswersError, setNoEnoughSelectedAnswersError] = useState(false);
    let [isFormSubmitted, setIsFormSubmitted] = useState(false);
    let [modalActionButtonLoading, setModalActionButtonLoading] = useState(false);
    let [values, setValues] = useState({
        question: '',
        is_multiple_answer_question: false,
        answers: [],

    });
    let [selectedAnswerCount, setSelectedAnswerCount] = useState(0);

    const schema = yup.object({
        question: yup.string().trim().required('Required'),
        is_multiple_answer_question: yup.boolean().required('Required'),
        answers: yup.array().of(
            yup.object().shape({
                answer: yup.string().trim().required('Required'),
                is_correct: yup.boolean()
            })
        ),

    })



    const addAnswerField = (e, values, setValues) => {

        const answers = [...values.answers];

        let newAnswer = {
            answer: '',
            is_correct: false
        }

        answers.push(newAnswer);
        setValues({ ...values, answers });

    }

    const removeAnswerField = (e, id, values, setValues) => {
        const answers = [...values.answers];
        if (answers.length !== 0) {
            let newArray = answers.filter(function (obj, index) {
                return index !== id;
            });
            setValues({ ...values, answers: newArray });
        }
    }

    const onSubmit = async (values) => {

        setIsFormSubmitted(true);
        setModalActionButtonLoading(true);

        for (var i = 0; i < values.answers.length; i++) {
            if (values.answers[i].is_correct) {
                selectedAnswerCount = selectedAnswerCount + 1;
            }
        }

        if (values.is_multiple_answer_question && (values.answers.length < 2 || selectedAnswerCount < 2)) {
            setNoEnoughSelectedAnswersError(true);
            setModalActionButtonLoading(false);
        }
        else if (!values.is_multiple_answer_question && (values.answers.length < 2 || selectedAnswerCount < 1)) {
            setNoEnoughSelectedAnswersError(true);
            setModalActionButtonLoading(false);
        }

        else {
            let response = await addQuestionToQuizTemplate(values, props.id);
            if (response.success == true) {
                props.handleClose();
                props.refreshData();
                setModalActionButtonLoading(false);
            } else {
                setModalActionButtonLoading(false);
            }
        }

    }

    const handleRadioButtonChange = async (answers, selected_index) => {

        setNoEnoughSelectedAnswersError(false);
        for (var i = 0; i < answers.length; i++) {
            if (i == selected_index) {
                answers[i].is_correct = true;

            }
            else {
                answers[i].is_correct = false;
            }
        }
    }


    return (
        <div>

            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Add Question</h2>
                    </div>
                    <div className={styles.modalHeader2Div}>
                        <h2 className={styles.modalHeader2}>{props.quizTemplateData.name} - <span className={styles.modalHeader2QuestionName} >Question {props.quizTemplateData.question_count + 1}</span></h2>
                    </div>
                    <Col sm={12}>
                        <Formik
                            enableReinitialize
                            validationSchema={schema}
                            onSubmit={(values) => onSubmit(values)}
                            initialValues={{ question: values.question, answers: values.answers, is_multiple_answer_question: values.is_multiple_answer_question, selectedAnswerCount: selectedAnswerCount}}
                        >
                            {({
                                values,
                                errors,
                                setFieldValue,
                                handleChange,
                                handleSubmit,
                                submitCount,
                                touched,
                                setValues
                            }) => (
                                <Form noValidate onSubmit={handleSubmit}>

                                    <Form.Group controlId="exampleForm.ControlTextarea1">
                                        <Form.Label className={styles.textareaLabel}>
                                            Question &nbsp;
                                            <svg data-tip data-for={`quizQuestionToolTip`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`quizQuestionToolTip`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}><p> Enter the question. Put a question mark at the end.</p></div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <Form.Control as="textarea" name="question" onChange={handleChange} rows={3} className={styles.textareaBox} isInvalid={errors.question || emptyQuestionError} onFocus={() => { setEmptyQuestionError(false); setIsFormSubmitted(false); }} />
                                        <p className={styles.errorMessageComments}>{errors.question}</p>
                                    </Form.Group>
                                    <div className={styles.divider}></div>
                                    <div className={styles.toggleContainer}>
                                        <span>
                                            <p className={styles.defaultLabel}> Multiple Answers &nbsp;
                                                <svg data-tip data-for={`quizQuestionTypeToolTip`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                <ReactTooltip id={`quizQuestionTypeToolTip`} place="right" type="dark" effect="solid" clickable={true}>
                                                    <div className={styles.toolTipBox}><p> Choose if the question has more than one answer.</p></div>
                                                </ReactTooltip> </p>
                                        </span>
                                        <span className='ml-3'>
                                            <CustomSwitch
                                                id='is_multiple_answer_question'
                                                classType={values.is_multiple_answer_question ? "animateSwitchActive" : "animateSwitch"}
                                                handleChange={(e) => { setMultipleAnswers(!isMultipleAnswers); setFieldValue('is_multiple_answer_question', !isMultipleAnswers); setIsFormSubmitted(false); }}
                                                isChecked={values.is_multiple_answer_question}
                                            />
                                        </span>
                                    </div>

                                    <div>
                                        <p className={styles.textareaLabel}>Answers</p>
                                        <Row>
                                            <Col className={styles.alertBoxTop}>
                                                <CustomAlertBox
                                                    alertBodyText="Enter answer options (including correct options and incorrect options). Mark the correct answer options by clicking the radio button or check box in front of the answer."
                                                    alertType="defaultAlert"
                                                />
                                            </Col>
                                        </Row>
                                        <FieldArray name="answers">
                                            {() => (values.answers && values.answers.map((answer, i) => {

                                                const answerErrors = ((errors.answers?.length) && (errors.answers[i])) || {};
                                                const answerTouched = ((touched.answers?.length) && (touched.answers[i])) || {};
                                                return (
                                                    <div key={i}>

                                                        <Row>
                                                            <Col lg={1} className='mt-1'>
                                                                {(isMultipleAnswers) ?
                                                                    <div>
                                                                        <CustomCheckBox
                                                                            id={i}
                                                                            controlId={`answer.${i}`}
                                                                            name={`answer.${i}.is_correct`}
                                                                            handleOnChange={() => { setFieldValue(`answers.${i}.is_correct`, !answer.is_correct); setNoEnoughSelectedAnswersError(false); setIsFormSubmitted(false); }}
                                                                            type="defaultCheckBox"
                                                                            value={answer.is_correct}
                                                                            ischecked={answer.is_correct}

                                                                        />
                                                                    </div>
                                                                    :
                                                                    <div>
                                                                        <Form.Check
                                                                            inline
                                                                            name="answers"
                                                                            type="radio"
                                                                            checked={answer.is_correct === true ? true : false}
                                                                            className={styles.radioBtns}
                                                                            onChange={() => { setFieldValue(`answers.${i}.is_correct`, !answer.is_correct); handleRadioButtonChange(values.answers, i); setIsFormSubmitted(false); }}
                                                                            id={i}
                                                                        />



                                                                    </div>
                                                                }
                                                            </Col>
                                                            <Col>
                                                                <CustomTextField
                                                                    keyValue={i}
                                                                    classLabel="defaultLabel"
                                                                    controlId={`answers.${i}`}
                                                                    type="text"
                                                                    value={(values && values.answers && values.answers[i]) && values.answers[i].answer}
                                                                    handleOnChange={handleChange}
                                                                    name={`answers.${i}.answer`}
                                                                    classType="defaultTextBox"
                                                                    onCancelClick={(e) => removeAnswerField(e, i, values, setValues)}
                                                                    errorMessage={(errors && errors.answers && errors.answers[i]) && errors.answers[i].answer}
                                                                    isInvalid={answerErrors.answer && answerTouched.answer}
                                                                    isCancelable={true}
                                                                />
                                                            </Col>
                                                        </Row>



                                                    </div>
                                                );
                                            }))}
                                        </FieldArray>
                                        <CustomButton
                                            buttonType="button"
                                            label="Add Answers"
                                            type="defaultBtn"
                                            handleClick={(e) => { addAnswerField(e, values, setValues); setIsFormSubmitted(false); }}

                                        />
                                        {isFormSubmitted && !values.is_multiple_answer_question && values.answers.length < 2 && <p className={styles.errorMessageComments}>Please add at least 2 answer options</p>}
                                        {isFormSubmitted && values.is_multiple_answer_question && values.answers.length < 2 && <p className={styles.errorMessageComments}>Please add at least 3 answer options</p>}
                                        {isFormSubmitted && !values.is_multiple_answer_question && selectedAnswerCount < 1 && noEnoughSelectedAnswersError && <p className={styles.errorMessageComments}>Please mark at least 1 correct answer</p>}
                                        {isFormSubmitted && values.is_multiple_answer_question && selectedAnswerCount < 2 && noEnoughSelectedAnswersError && <p className={styles.errorMessageComments}>Please mark at least 2 correct answers</p>}
                                    </div>

                                    <Row className={styles.btnRow}>


                                        <Col >
                                            <div className={styles.disconnectButton} >


                                                <CustomButton
                                                    type="primaryBtn"
                                                    label="Submit"
                                                    buttonType="submit"
                                                    disabled={modalActionButtonLoading === true ? true : false}
                                                    backicon={
                                                        modalActionButtonLoading === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                                            : ''
                                                    }
                                                />


                                            </div>
                                        </Col>
                                        <Col >
                                            <div className={styles.disconnectButton} >
                                                <CustomButton
                                                    type="defaultBtn"
                                                    label="Cancel"
                                                    buttonType="button"
                                                    disabled={modalActionButtonLoading === true ? true : false}
                                                    handleClick={props.handleClose}
                                                />
                                            </div>
                                        </Col>

                                    </Row>


                                </Form>
                            )}
                        </Formik>

                    </Col>

                </Modal.Body>

            </Modal>
        </div>
    )
}
export default CreateQuestionModal;